document.addEventListener("DOMContentLoaded", function () {
  const descriptionAccordion = document.getElementById("descriptionAccordion");
  if (descriptionAccordion) {
    document
      .querySelectorAll('[data-scroll-to="infoSectionScrollAnchor"]')
      .forEach(function (element) {
        element.addEventListener("click", function (event) {
          // if the description accordion is not active, click it to open
          if (
            !descriptionAccordion.parentElement.classList.contains("is-active")
          ) {
            setTimeout(() => {
              descriptionAccordion.click();
            }, 500);
          }
        });
      });
  }
});
